<template>
<div class="full">
  <CoverFilterSummary v-model="filters"></CoverFilterSummary>
  <v-data-table  :headers="claimedHeaders" :pagination.sync="pagination"
         :rows-per-page-items="pagination.rowsPerPageItems"
         :loading="loading"
         :total-items="pagination.totalItems"
         :items="covers" class="elevation-1" >
         <template slot="headers" slot-scope="props">
              <tr>
               <template v-for="header in props.headers">
                  <th  v-if="(extendedMode && (!userInfos.claimExtendedForm || !hiddenColumnforClaimExtendedForm.includes(header.value)))|| columnsAlwaysShown.includes(header.value)" :key="$t(header.text)" :class="$t(header.text).toUpperCase() === 'Action'.toUpperCase()?'text-xs-center' :'text-xs-left'">
                     {{ $t(header.text) }}
                   </th>
               </template>
              </tr>
        </template>
        <template v-slot:items="props">
          <tr @click="showCoverDetail(props.item.id)" v-bind:class="selectedRow === props.item.id ?'selectedrow' : ''">
            <td class="text-xs-left"></td>
            <td class="text-xs-left"><span class="twoline">{{ props.item.seller.name }}<span class="smalltext greytext"> {{ props.item.seller.identifierType }} {{ props.item.seller.identifierValue }} </span></span></td>
            <td class="text-xs-left"><span class="twoline">{{ props.item.buyer.name }}<br/><span class="smalltext greytext">{{ props.item.buyer.identifierType }} {{ props.item.buyer.identifierValue }}</span></span> </td>
            <td v-if="extendedMode" class="text-xs-left">{{ props.item.number }}</td>
            <td v-if="extendedMode" class="text-xs-left">{{ props.item.amount}}</td>
            <td class="text-xs-left">{{ $formatDate(props.item.claim.at) }} </td>
            <td v-if="extendedMode" class="text-xs-left">
              <v-tooltip top>
              <template v-slot:activator="{ on }">
                   <span class="color-circle" v-on="on" v-bind:style="{background:props.item.claim.owner.calculatedColor}"><p class="colorName">{{ props.item.claim.owner.initials }}</p> </span>
              </template>
               <span>{{ props.item.claim.owner.firstName }} {{ props.item.claim.owner.lastName }}</span>
              </v-tooltip>
              </td>
            <td v-if="extendedMode && !userInfos.claimExtendedForm" class="text-xs-left">{{ props.item.claim.ref }}</td>
            <td v-if="extendedMode && !userInfos.claimExtendedForm" class="text-xs-left">{{ props.item.claim.status}}</td>
            <td v-if="extendedMode" class="text-xs-center">
                  <v-btn @click.stop v-if="canSettleCover" color="primary" small @click="settleCover(props.item.id)">{{$t('Cover.ListCover.SETTLE_COVER_BTN')}}</v-btn>
            </td>
          </tr>
        </template>
        <template slot="no-data">
              <div v-if="loading" class="text-xs-center">
                    <v-progress-circular indeterminate  color="primary"></v-progress-circular>
              </div>
              <div v-else>
                  <p class="centerText"> {{$t('Cover.ListCover.NO_DATA_AVAILABLE_DESC')}} </p>
              </div>
        </template>
      </v-data-table>
</div>

</template>

<script>
import coverApi from '@/services/CoverApi'
import { mapState } from 'vuex'
import transactorApi from '@/services/TransactorApi'
import CoverFilterSummary from '@/components/common/CoverFilterSummary.vue'

export default {
  components: { CoverFilterSummary },
  data () {
    return {
      covers: [],
      columnsAlwaysShown: ['first', 'seller', 'buyer', 'claimedat'],
      hiddenColumnforClaimExtendedForm: ['claimref', 'claimstatus'],
      loading: true,
      autoRefreshTimer: null,
      paginationData: {
        descending: true,
        page: 1,
        rowsPerPage: 5,
        sortBy: 'id',
        totalItems: 0,
        rowsPerPageItems: [5]
      },
      selectedRow: '',
      emptyCompany: {
        id: '',
        name: '',
        identifierType: '',
        identifierValue: ''
      },
      emptyOwner: {
        firstName: '',
        lastName: '',
        initials: '',
        calculatedColor: '#ffffff'
      },
      snackbar: {
        show: false,
        color: '',
        timeout: 6000,
        text: ''
      }
    }
  },
  watch: {
    pagination: {
      async handler () {
        this.loading = true
        await this.searchCovers(this.filters.identifierValue, this.filters.identifierTypeCode, this.filters.identifierCountryCode, this.filters.coverId)
      }
    },
    filters: {
      async handler () {
        this.loading = true
        await this.searchCovers(this.filters.identifierValue, this.filters.identifierTypeCode, this.filters.identifierCountryCode, this.filters.coverId)
      }
    },
    deep: true
  },
  beforeDestroy () {
    this.cancelAutoUpdate()
  },
  methods: {
    cancelAutoUpdate: function () {
      window.clearInterval(this.autoRefreshTimer)
    },
    async searchCovers (identifierValue, identifierTypeCode, identifierCountryCode, coverId) {
      let transactorId = !!identifierValue && identifierValue.length > 0 ? await transactorApi.fetchCompanyByExternalId(identifierCountryCode, identifierTypeCode, identifierValue) : undefined
      let companyId = !!transactorId && transactorId.length > 0 ? transactorId : undefined
      if (!this.$isEmpty(identifierValue) && this.$isEmpty(companyId)) {
        this.covers = []
        this.loading = false
        return
      }
      let response = await coverApi.fetchCoversbyStatusPerPage(this.paginationData.page, this.paginationData.rowsPerPage, 'Claimed', 'quotedAt', null, null, 'claimedAt', 'desc', companyId, coverId)
      if (response.items.length === 0) {
        this.loading = false
        this.covers = []
        return
      }
      this.covers = response.items.map((item) => {
        return {
          id: item.id,
          sellerId: item.sellerId,
          buyerId: item.buyerId,
          number: item.invoice.number,
          amount: item.invoice.amount + ' ' + item.invoice.currency.toUpperCase(),
          claim: item.claim === undefined ? { owner: this.emptyOwner } : {
            at: item.claim.createdAt,
            ref: item.claim.externalId,
            status: this.claimStatus.findIndex(x => x.name === item.claim.status) >= 0 ? this.claimStatus.find(x => x.name === item.claim.status).label : this.$toTitleCase(item.claim.status),
            owner: {
              firstName: item.claim.owner.firstName,
              lastName: item.claim.owner.lastName,
              initials: item.claim.owner.firstName.charAt(0) + '' + item.claim.owner.lastName.charAt(0),
              calculatedColor: this.$strToColor(item.claim.owner.lastName + ' ' + item.claim.owner.firstName)
            }
          },
          submitted: false,
          seller: this.emptyCompany,
          buyer: this.emptyCompany
        }
      })
      this.paginationData.totalItems = response.totalCount
      this.$store.dispatch('listcovertabs/setCoversClaimedCount', response.totalCount)

      let sellerIds = this.covers.map((item) => { return item.sellerId })
      let buyerIds = this.covers.map((item) => { return item.buyerId })
      let companyIds = [...new Set(sellerIds.concat(buyerIds))]
      let companies = await this.getcompanies(companyIds)
      this.covers.forEach(function (cover) {
        cover.seller = companies.find(function (company) {
          return company.id === cover.sellerId
        })

        cover.buyer = companies.find(function (company) {
          return company.id === cover.buyerId
        })
      })
      this.loading = false
    },
    async showCoverDetail (coverId) {
      this.selectedRow = coverId
      this.$parent.setHeightForSideInfo()
      this.$store.dispatch('cover/setExtendedMode', false)
      await this.$parent.showCoverInfoDetail(coverId, false, 'Claimed', false)
    },
    async getcompanies (companies) {
      let resultcompanies = await coverApi.fetchCompaniesId(companies)
      return resultcompanies.items.map((item) => {
        return {
          id: item.id,
          name: item.name,
          ehId: item.ehId,
          identifierType: item.identifierType,
          identifierValue: item.identifierValue
        }
      })
    },
    async settleCover (coverId) {
      let success = await this.$parent.settleCover(coverId)
      if (success) {
        this.$store.dispatch('listcovertabs/updateCoversClaimedCount')
        await this.searchCovers(this.filters.identifierValue, this.filters.identifierTypeCode, this.filters.identifierCountryCode, this.filters.coverId)
      }
    }
  },
  computed: {
    pagination: {
      get: function () {
        return this.paginationData
      },
      set: function (value) {
        this.paginationData = value
      }
    },
    items () {
      return this.covers
    },
    canSettleCover: function () {
      return this.$parent.hasCoverageAccess()
    },
    ...mapState('cover', ['extendedMode', 'claimedHeaders', 'claimStatus']),
    ...mapState('userdetails', ['userInfos']),
    ...mapState('listcovertabs', ['filters'])
  }
}
</script>
<style>
.color-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;

   display: inline-block;
  vertical-align: middle;

}
.colorName{
  text-align: center;
  margin-top: 12px;
  color: white;
}
</style>
